module.exports = __webpack_public_path__ + "img/void.dd87c13d.svg";